import { FC, useEffect, useState } from "react";
import {
  Box,
  Dialog,
  Grid,
  IconButton,
  Typography,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import ReactPlayer from "react-player";
import { MdClose } from "react-icons/md";
import useStyles from "../Styles/ProjectModalStyles";
import { getPoolQuizVideosFunction } from "../../store/Learn2/LearnFunction";
import videoplaceholder from "../../assets/images/videoplaceholder.jpg";
import playicon from "../../assets/images/play.svg";

type QuizVideosModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  poolId: string;
};

const Playicon = () => {
  return <img src={playicon} alt="play" className="img-fluid" />;
};

const QuizVideosModal: FC<QuizVideosModalProps> = ({ open, setOpen, poolId }) => {
  const classes = useStyles();
  const [videos, setVideos] = useState<any[]>([]);
  const [currentVideo, setCurrentVideo] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const handleClose = (event?: React.SyntheticEvent<any, Event>, reason?: string) => {
    if (reason === "backdropClick") return;
    setOpen(false);
  };

  useEffect(() => {
    if (!poolId) return;

    setLoading(true);
    getPoolQuizVideosFunction(poolId)
      .then((response: any) => {
        const result = response?.getPoolQuizzes || [];
        if (Array.isArray(result) && result.length > 0) {
          setVideos(result);
          setCurrentVideo(result[0].lessonContent);
        }
      })
      .catch((error: any) => {
        console.error("Error fetching pool quizzes:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [poolId]);

  return (
    <Box component="section">
      <Dialog
        open={open}
        onClose={() => handleClose()}
        aria-labelledby="quiz-video"
        className={classes.modalpages}
        maxWidth="md"
        fullWidth
      >
        <Box p={2}>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Learn More about the Project</Typography>
            <IconButton onClick={(event) => handleClose(event, "buttonClick")}>
              <MdClose />
            </IconButton>
          </Grid>

          <Box mt={2} style={{ position: "relative", width: "100%" }}>
            <Box
              style={{
                width: "100%",
                height: "300px", // fixed height to preserve space
                backgroundColor: "#f0f0f0",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {loading || !currentVideo ? (
                <CircularProgress />
              ) : (
                <ReactPlayer
                  url={currentVideo}
                  controls
                  width="100%"
                  height="100%"
                  className="video-clip"
                  playIcon={<Playicon />}
                />
              )}
            </Box>
          </Box>

          {videos.length > 1 && (
            <>
              <Divider style={{ margin: "20px 0" }} />
              <Grid container>
                <Typography variant="body1" style={{ marginBottom: 5 }}>
                  All Videos
                </Typography>
              </Grid>
              <Grid container spacing={2}>
                {videos.map((video, index) => (
                  <Grid item xs={4} md={3} key={video.id}>
                    <Box
                      onClick={() => setCurrentVideo(video.lessonContent)}
                      style={{
                        cursor: "pointer",
                        borderRadius: 6,
                        overflow: "hidden",
                        border: currentVideo === video.lessonContent
                          ? "2px solid #3EB8AA"
                          : "2px solid transparent",
                        transition: "border 0.3s ease",
                      }}
                    >
                      <img
                        src={videoplaceholder}
                        alt={`Video ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block",
                        }}
                      />
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </>
          )}
        </Box>
      </Dialog>
    </Box>
  );
};

export default QuizVideosModal;